import { Component, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router, RouterOutlet } from '@angular/router';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { UserService } from "./core/auth/user-service/user.service";
import { AuditLogsService } from "./core/services/audit-logs-service/audit-logs.service";
import { IdleService } from "./core/services/idle-service/idle.service";

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatProgressSpinnerModule,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  router = inject(Router);
  userService = inject(UserService);
  private auditLogsService = inject(AuditLogsService);
  private idleService = inject(IdleService);

  loadingRouteConfig = signal(false);
  loadingUser = this.userService.loadingUser;

  title = 'SSBA-Frontend';

  ngOnInit() {
    /**
     * Handle module lazy loading state
     * https://stackoverflow.com/questions/42981136/show-activity-indicator-while-loading-a-lazy-loaded-module-in-angular-2
     */
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig.set(true);
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig.set(false);
      }
    });
  }

  protected onUserAction(): void {
    this.idleService.resetTimer();
  }

}
